import MUITextArea from '@mui/material/TextareaAutosize'

export const TextArea = MUITextArea
